import { Component, OnDestroy, OnInit, ViewEncapsulation, Injector, Type, createNgModule, inject } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FuseLegacyConfigService, LegacyFuseConfig } from "@nx-workspace/fuse";
import { navigation } from "app/navigation/navigation";
import { Layout1Service } from "@app/layout/vertical/layout-1/layout-1.service";
import { AudioService } from "@app/audio.service";
import { ChatPanelService } from "app/wapps/chat-panel/chat-panel.service";
import { AppConsts } from "@shared/AppConsts";
import { AppSessionService } from "@vadmin/account/auth";

@Component({
    selector: "vertical-layout-1",
    templateUrl: "./layout-1.component.html",
    styleUrls: ["./layout-1.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
    readonly appSession = inject(AppSessionService);

    fuseConfig: LegacyFuseConfig;

    navigation: any;

    private _unsubscribeAll: Subject<any>;

    chatEnabled: boolean;

    chatPanelComponent: Type<unknown> | null = null;

    chatPanelInjector: Injector | null = null;

    private chatPanelLoading = false;

    v2Enabled: boolean = abp.setting.get(AppConsts.Settings.ApplicationVersion) === "2.0";

    constructor(
        private _injector: Injector,
        private _service: Layout1Service,
        private _fuseConfigService: FuseLegacyConfigService,
        private _internalChatService: ChatPanelService,
        private _audioService: AudioService
    ) {
        this.navigation = navigation;
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config: LegacyFuseConfig) => {
            this.fuseConfig = {
                ...config,
                layout: {
                    ...config.layout,
                    toolbar: {
                        ...config.layout.toolbar,
                        position: this.v2Enabled ? "above" : config.layout.toolbar.position,
                    },
                },
            };
        });

        this._internalChatService.chatEnabled.pipe(takeUntil(this._unsubscribeAll)).subscribe((chatEnabled) => {
            this.chatEnabled = chatEnabled;

            if (chatEnabled) {
                this.loadChatPanel();
            }
        });
    }

    private loadChatPanel(): void {
        if (this.chatPanelComponent || this.chatPanelLoading) {
            return;
        }

        this.chatPanelLoading = true;

        Promise.all([
            import("@app/wapps/chat-panel/chat-panel.module"),
            import("@app/wapps/chat-panel/xmpp/xmpp.component"),
        ])
            .then(([{ ChatPanelWappModule }, { XmppComponent }]) => {
                this.chatPanelInjector = createNgModule(ChatPanelWappModule, this._injector).injector;
                this.chatPanelComponent = XmppComponent;
            })
            .catch((error) => {
                console.error("Failed to load the chat panel", error);
            })
            .finally(() => {
                this.chatPanelLoading = false;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onNavbarOpenedChanged(opened: boolean) {
        this._service.navbarOpened = opened;
    }

    onNavbarFoldedChanged(folded: boolean) {
        this._service.navbarFolded = folded;
    }

    globalClick() {
        this._audioService.init();
    }
}
